import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

// initial state
const state = {
  search: {
    keyword: '',
    page: 1,
    limit: 12,
    status: false,
    result: {
      products: [],
      page: {
        number: 1,
        page_count: 12
      }
    },
    scroll: 0
  },
  result: {
    list: [],
    page_count: 15,
    page: 1
  },
  detail: {
    normal_price: '',
    special_price: '',
    member_price: ''
  },
  selectedQuantity: 1
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products/index.js